import { Component } from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Textarea.module.css'

class Textarea extends Component {
  state = { value: this.defaultValue() }

  /**
   * Passing `value` opts into a controlled textarea, so the owner can reset the
   * field (discarding an edit, for instance). Without it the component keeps
   * its own state seeded from `defaultValue`, as it always has.
   */
  isControlled() {
    return this.props.value !== undefined
  }

  currentValue() {
    return this.isControlled() ? this.props.value : this.state.value
  }

  defaultValue() {
    return this.props.defaultValue || ''
  }

  componentDidUpdate() {
    if (this.isControlled()) {
      return
    }
    if (this.state.value === '' && this.state.value !== this.defaultValue()) {
      this.setState({ value: this.defaultValue() })
    }
  }

  handleChange = (event) => {
    const {
      target: { value },
    } = event
    const { maxLength } = this.props

    const truncatedChars = maxLength ? value.slice(0, maxLength) : value
    if (truncatedChars === this.currentValue()) {
      return
    }
    if (!this.isControlled()) {
      this.setState({ value: truncatedChars })
    }
    this.props.onChange(event, {
      value: truncatedChars,
      defaultValue: this.defaultValue(),
    })
  }

  handleBlur = (event) => {
    this.props.onBlur(event, {
      value: this.currentValue(),
      defaultValue: this.defaultValue(),
    })
  }

  render() {
    const { disabled, name, className, placeholder, error, success } =
      this.props
    return (
      <div
        className={classNames(styles.Textarea, className, {
          [styles.disabled]: disabled,
          [styles.success]: !error && success,
          [styles.error]: !success && error,
        })}
      >
        <textarea
          name={name}
          onBlur={this.handleBlur}
          value={this.currentValue()}
          disabled={disabled}
          onChange={this.handleChange}
          placeholder={placeholder}
        />
      </div>
    )
  }
}

Textarea.propTypes = {
  /** Opts into a controlled textarea. Leave undefined to keep internal state. */
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  success: PropTypes.bool,
  error: PropTypes.bool,
  name: PropTypes.string,
}

Textarea.defaultProps = {
  defaultValue: '',
  disabled: false,
  className: null,
  onChange: () => {},
  onBlur: () => {},
  maxLength: null,
  placeholder: '',
  success: false,
  error: false,
  name: null,
}

export default Textarea
